import LookupService from './service';
import {
  District,
  DistrictsByCode,
  GetNwpGpPermitTypesOpts,
  LookupTablesData,
  CreditUnit,
  DivisionsAndDistrictsData,
  HelpCategoryLookupItem,
} from './types';

export const LOOKUP_QUERY_KEYS = {
  GET_DISTRICTS: 'GET_DISTRICTS',
  GET_STATES: 'GET_STATES',
  GET_NWP_GP_PERMIT_TYPES: 'GET_NWP_GP_PERMIT_TYPES',
  GET_ALL_TABLES: 'GET_ALL_TABLES',
  GET_CREDIT_UNITS_BY_DISTRICT: 'GET_CREDIT_UNITS_BY_DISTRICT',
  GET_DIVISIONS_AND_DISTRICTS: 'GET_DIVISIONS_AND_DISTRICTS',
  GET_HELP_CATEGORIES: 'GET_HELP_CATEGORIES',
};

export class LookupQueries {
  public static readonly getDistricts = async (): Promise<DistrictsByCode> => {
    const { data } = await LookupService.getDistricts();

    const districtsByCode: DistrictsByCode = {};

    data.forEach((district: District) => {
      if (!districtsByCode[district.orgShortName]) {
        districtsByCode[district.orgShortName] = {
          orgAddress: district.orgAddress,
          orgName: district.orgName,
          orgPhone: district.orgPhone,
          orgUrl: district.orgUrl,
        };
      }
    });

    return districtsByCode;
  };

  public static readonly getDistrictsList = async (): Promise<District[]> => {
    const { data } = await LookupService.getDistricts();
    return data;
  };

  public static readonly getDivisionsAndDistricts = async (): Promise<DivisionsAndDistrictsData> => {
    const { data } = await LookupService.getDivisionsAndDistricts();
    return data;
  };

  public static readonly getNwpGpPermitTypes = async (): Promise<GetNwpGpPermitTypesOpts> => {
    const data = await LookupService.getNwpGpPermitTypes();
    return data;
  };

  public static readonly getAllTables = async (): Promise<LookupTablesData> => {
    const { data } = await LookupService.getAllTables();
    return data;
  };

  public static readonly getCreditUnitsForDistrict = async (district: string): Promise<CreditUnit[]> => {
    const { data } = await LookupService.getCreditUnitsForDistrict(district);
    return data;
  };

  public static readonly getHelpCategories = async (active = true): Promise<HelpCategoryLookupItem[]> => {
    const { data } = await LookupService.getHelpCategories(active);
    return data;
  };
}
